export default __webpack_public_path__ + "static/media/FTSE_350_Rankings_Report_Dec_2019.e7473dd3.pdf";